import { docReady } from '../helpers/docReady';
import '../../styles/templates/article.scss';
import { articleFooter } from '../sections/articleFooter';
docReady(() => {
    articleFooter();
});
